import type { LabelColor } from '@/lib/api/types';

/** The palette, in the order the picker offers it. */
export const LABEL_COLORS: LabelColor[] = [
  'slate',
  'red',
  'amber',
  'green',
  'teal',
  'blue',
  'violet',
  'pink',
];
